import { Box, Button, CssGrid, Grid, GridItemGrow, Text } from "designSystem/index";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import React from "react";

interface CardProps {
	n: number;
}

const Card = (props: CardProps) => {
	const { n } = props;
	const h = 20 + Math.trunc(50 * Math.random());

	return (
		<Box
			bgcolor="background.paper"
			border={STANDARD_BORDER_STYLE}
			height={1}
			p={2}
		>
			<Grid
				container
				direction="column"
				fullHeight
				spacing={2}
				wrap="nowrap"
			>
				<Grid item>
					<Text text={`Card ${n}`} variant="subtitle1" />
				</Grid>
				<GridItemGrow>
					<Box
						bgcolor="grey.100"
						border={STANDARD_BORDER_STYLE}
						height={h}
					>
						<Text text="Attributes" />
					</Box>
				</GridItemGrow>
				<Grid item>
					<Button design="secondary" fullWidth>Select</Button>
				</Grid>
			</Grid>
		</Box>
	);
};

export default () => {
	const children = [];

	for (let i = 0; i < 40; ++i) {
		children.push(<Card key={i} n={i} />);
	}

	return (
		<CssGrid columns={4} spacing={2}>
			{children}
		</CssGrid>
	);
};